// Mirrors backend/app/schemas/auth.py - keep these in sync.
import { apiClient } from "./client";

export interface AuthUser {
    user_id: string;
    username: string;
}

export interface AuthMeResponse {
    authenticated: boolean;
    user: AuthUser | null;
}

export interface AuthSessionResponse {
    user: AuthUser;
    expires_at: string;
}

export async function fetchMe(): Promise<AuthMeResponse> {
    const { data } = await apiClient.get<AuthMeResponse>("/auth/me");
    return data;
}

export async function register(username: string, password: string): Promise<AuthSessionResponse> {
    const { data } = await apiClient.post<AuthSessionResponse>("/auth/register", {
        username,
        password,
    });
    return data;
}

export async function login(
    username: string,
    password: string,
    rememberMe: boolean,
): Promise<AuthSessionResponse> {
    const { data } = await apiClient.post<AuthSessionResponse>("/auth/login", {
        username,
        password,
        remember_me: rememberMe,
    });
    return data;
}

export async function logout(): Promise<void> {
    await apiClient.post("/auth/logout");
}
